var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronRight = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.21967 18.5303C8.92678 18.2374 8.92678 17.7626 9.21967 17.4697L14.6893 12L9.21967 6.53033C8.92678 6.23744 8.92678 5.76256 9.21967 5.46967C9.51256 5.17678 9.98744 5.17678 10.2803 5.46967L16.2803 11.4697C16.5732 11.7626 16.5732 12.2374 16.2803 12.5303L10.2803 18.5303C9.98744 18.8232 9.51256 18.8232 9.21967 18.5303Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevron-right.147b3b53b8e967f799ec8f0f69deb6d0.svg";